<template>
	<div class="viewer-controls">
		<div v-tippy="{ placement: 'right', hideOnClick: false }" :title="`Zoom: ${sizes[size]}%`">
			<button v-if="item.zoom_enabled" class="md-btn md-fab md-fab-sm mb-2 theme" @click="zoomIn()">
				<i class="far fa-search-plus"></i>
			</button>
			<button v-if="item.zoom_enabled" class="md-btn md-fab md-fab-sm mb-2 theme" @click="zoomOut()">
				<i class="far fa-search-minus"></i>
			</button>
		</div>
		<button
			v-if="item.angle_enabled"
			class="md-btn md-fab md-fab-sm mb-2 theme"
			@click="angleOn()"
			v-tippy="{ placement: 'right' }"
			title="Angle Tool"
		>
			<i class="far fa-triangle"></i>
		</button>
		<button
			v-if="item.rotate_enabled"
			class="md-btn md-fab md-fab-sm mb-2 theme"
			@click="rotate()"
			v-tippy="{ placement: 'right' }"
			title="Rotate"
		>
			<i class="far fa-sync-alt"></i>
		</button>
		<button
			v-if="item.invert_enabled"
			class="md-btn md-fab md-fab-sm mb-2 theme"
			@click="invert()"
			v-tippy="{ placement: 'right' }"
			title="Invert"
		>
			<i class="fas fa-image"></i>
		</button>
		<!-- <button class="md-btn md-fab md-fab-sm mb-2 theme" @click="highlight()">
			<i class="far fa-beer"></i>
		</button> -->
	</div>
</template>

<script>
import store from "@/services/Store";

export default {
	name: "ViewerControls",
	props: ["chan", "item", "showNotes"],
	data() {
		return {
			size: 1,
			sizes: [50, 65, 80, 100, 120, 150, 180, 200]
		};
	},

	created() {
		this.size = store.get(this, "viewerScale");
		if (!this.size && this.size != 0) {
			this.size = 1;
		}
	},

	methods: {
		zoomIn() {
			this.size++;
			if (this.size > 7) {
				this.size = 7;
			}
			store.set(this, "viewerScale", this.size);
			this.chan.$emit("zoom-in");
		},
		zoomOut() {
			this.size--;
			if (this.size < 0) {
				this.size = 0;
			}
			store.set(this, "viewerScale", this.size);
			this.chan.$emit("zoom-out");
		},
		invert() {
			this.chan.$emit("invert");
		},
		rotate() {
			this.chan.$emit("rotate");
		},
		angleOn() {
			this.chan.$emit("angle-on");
		},
		highlight() {
			this.chan.$emit("highlight");
		}
	}
};
</script>

<style scoped>
.viewer-controls {
	position: absolute;
	left: 20px;
	top: 20px;
}
.viewer-controls button {
	display: block;
	font-size: 20px;
	line-height: 2;
}
.md-fab-sm {
	height: 40px !important;
	width: 40px !important;
	padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/viewer/ViewerControls.vue